import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import styled, {css} from "styled-components";
import StarImg from "@PUBLIC/P/images/ico/ico_star.png";

const StarIcon = styled.i`
	display: inline-block;
	width: 14px;
	height: 14px;
	background: url(${SpriteImage}) -1px -27px / 400px 400px no-repeat;
`;

const StarIconBase = styled.i`
	display: inline-block;
	width: 14px;
	height: 14px;
	background: url(${SpriteImage}) -60px -27px / 400px 400px no-repeat;
`;

const StarScore = styled.span`
	width: 74px;
	display: inline-block;
	height: 14px;
	overflow: hidden;
	background: url(${StarImg}) no-repeat;
	text-align: left;

	span {
		display: inline-block;
		height: 14px;
		overflow: hidden;
		background: url(${StarImg}) no-repeat;
		background-position: left bottom;
		line-height: 0;
		vertical-align: top;
	}
`;

const Tag = styled.span<{name: string}>`
	display: flex;
	height: 20px;
	padding: 0 10px;
	font-size: 12px;
	justify-content: center;
	align-items: center;

	${props =>
		(props.name === "recommend" || props.name === "promotion") &&
		css`
			border: 1px solid var(--red-color);
			color: var(--red-color);
		`}
`;

const TagGroup = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1;
`;

const TagSquare = styled.span<{tag: string}>`
	display: inline-flex;
	align-items: center;
	height: 24px;
	padding: 0 8px;
	border-radius: 4px;
	background-color: ${props => {
		if (props.tag === "pkg") {
			// 해외패키지
			return "#5778bb";
		}
		if (props.tag === "fit") {
			// 에어텔
			return "#549ec9";
		}
		if (props.tag === "honey") {
			// 허니문
			return "#c159c0";
		}
		if (props.tag === "golf") {
			// 골프
			return "#4fa344";
		}
		if (props.tag === "cruise") {
			// 크루즈
			return "#5e90e3";
		}
		if (props.tag === "dmt") {
			// 국내여행
			return "#e67f4c";
		}
		if (props.tag === "biz") {
			// 기업단체
			return "#7291a5";
		}
		if (props.tag === "air") {
			// 항공
			return "#57bbb5";
		}
		if (props.tag === "hotel") {
			// 호텔
			return "#895eb5";
		}
		if (props.tag === "tour") {
			// 투어
			return "#e072a4";
		}
		if (props.tag === "rent") {
			// 렌터카
			return "#3a59cc";
		}
		if (props.tag === "semi") {
			// 세미패키지
			return "#009acf";
		}
		if (props.tag === "pilgrimage") {
			// 성지순례
			return "#6a5fbc";
		}
		if (props.tag === "discount") {
			// 특가상품
			return "#b94b60";
		}

		if (props.tag === "tranking") {
			return css`#008400`;
		}
		if (props.tag === "pilgrimage") {
			return css`#6a5fbc`;
		}
		if (props.tag === "ticket") {
			return css`#e0a446`;
		}
		if (props.tag === "local") {
			return css`#89a852`;
		}
		if (props.tag === "discount") {
			return css`#b94b60`;
		}
		if (props.tag === "percent") {
			return css`#e94c4c`;
		}
		if (props.tag === "coupon") {
			return css`#009acf`;
		}
		if (props.tag === "other") {
			return css`#777`;
		}
		if (props.tag === "code") {
			return css`#222`;
		}
		if (props.tag === "tourtype") {
			return css`#c6a3dc`;
		}
		if (props.tag === "pre") {
			return css`#333`;
		}
		if (props.tag === "arrival") {
			return css`#7f905e`;
		}
		if (props.tag === "bargain") {
			return css`#78909a`;
		}
	}};
	color: #fff;
	font-size: 13px;
	font-family: "pr-font-regular";
	box-sizing: border-box;
	line-height: 1;
`;

const TagProduct = styled.span<{flag: string}>`
	display: inline-flex;
	align-items: center;
	height: 24px;
	padding: 0 8px;
	border-radius: 4px;
	background-color: ${props => {
		if (props.flag === "pkg") {
			// 해외패키지
			return "#5778bb";
		}
		if (props.flag === "fit") {
			// 에어텔
			return "#549ec9";
		}
		if (props.flag === "honey") {
			// 허니문
			return "#c159c0";
		}
		if (props.flag === "golf") {
			// 골프
			return "#4fa344";
		}
		if (props.flag === "cruise") {
			// 크루즈
			return "#5e90e3";
		}
		if (props.flag === "dmt") {
			// 국내여행
			return "#e67f4c";
		}
		if (props.flag === "biz") {
			// 기업단체
			return "#7291a5";
		}
		if (props.flag === "air") {
			// 항공
			return "#57bbb5";
		}
		if (props.flag === "hotel") {
			// 호텔
			return "#895eb5";
		}
		if (props.flag === "tour") {
			// 투어
			return "#e072a4";
		}
		if (props.flag === "rent") {
			// 렌터카
			return "#3a59cc";
		}
		if (props.flag === "semi") {
			// 세미패키지
			return "#009acf";
		}
		if (props.flag === "pilgrimage") {
			// 성지순례
			return "#6a5fbc";
		}
		if (props.flag === "discount") {
			// 특가상품
			return "#b94b60";
		}
	}};
	color: #fff;
	font-size: 13px;
	font-family: "pr-font-regular";
	box-sizing: border-box;
	line-height: 1;

	@media print {
		font-size: 24px;
		height: 32px;
	}
`;

const TagBrand = styled.span<{flag: string}>`
	display: inline-flex;
	align-items: center;
	height: 24px;
	padding: 0 8px;
	border-radius: 4px;
	background-color: ${props => {
		if (props.flag === "premium") {
			// 프리미엄
			return "#222";
		}
		if (props.flag === "light") {
			// 라이트팩
			return "#a6cc25";
		}
		if (props.flag === "percent") {
			// 100% 출발확정
			return "#e94c4c";
		}
	}};
	color: #fff;
	font-size: 13px;
	font-family: "pr-font-regular";
	box-sizing: border-box;
	line-height: 1;
`;

const TagType = styled.span`
	display: inline-flex;
	align-items: center;
	height: 24px;
	padding: 0 8px;
	border-radius: 4px;
	background-color: #def5e5;
	color: #11a740;
	font-size: 13px;
	font-family: "pr-font-regular";
	box-sizing: border-box;
	line-height: 1;

	@media print {
		font-size: 24px;
		height: 32px;
	}
`;

const TagEmp = styled.span`
	display: inline-flex;
	align-items: center;
	height: 24px;
	padding: 0 8px;
	border-radius: 4px;
	background-color: #fdecec;
	color: #f23f45;
	font-size: 13px;
	font-family: "pr-font-regular";
	box-sizing: border-box;
	line-height: 1;

	@media print {
		font-size: 24px;
		height: 32px;
	}
`;

const TagProcess = styled.span<{flag: string}>`
	display: inline-flex;
	align-items: center;
	height: 24px;
	padding: 0 8px;
	border-radius: 4px;
	${props => {
		if (props.flag === "impending") {
			/** 마감임박 **/
			return `    
					border: 1px solid #ef8e25;
					box-sizing: border-box;
					background: #faf2e9;
					color: #ef8e25;
				`;
		}
		if (props.flag === "planning") {
			/** 출발예정 **/
			return `    
					border: 1px solid #5f9cbc;
					box-sizing: border-box;
					background: #ecf5f9;
					color: #5f9cbc;
				`;
		}
		if (props.flag === "decided") {
			/** 출발확정 **/
			return `    
					border: 1px solid #e94c4c;
					box-sizing: border-box;
					background: #faefe9;
					color: #e94c4c;
				`;
		}
		if (props.flag === "percent") {
			/** 100%출발확정 **/
			return `
					border: 1px solid #e94c4c;
					box-sizing: border-box;
					background: #faefe9;
					color: #e94c4c;
				`;
		}
		if (props.flag === "deadline") {
			/** 예약마감 **/
			return `    
					border: 1px solid #999999;
					box-sizing: border-box;
					background: #f6f6f6;
					color: #999999;
				`;
		}
	}}
	font-size: 13px;
	font-family: "pr-font-regular";
	box-sizing: border-box;
	line-height: 1;

	@media print {
		font-size: 24px;
		height: 32px;
	}
`;

const TagCode = styled.span`
	display: inline-flex;
	align-items: center;
	height: 24px;
	padding: 0 8px;
	border-radius: 4px;
	background-color: #495263;
	font-size: 13px;
	font-family: "pr-font-regular";
	box-sizing: border-box;
	line-height: 1;
	color: #fff;
`;

export {
	StarIcon,
	StarIconBase,
	Tag,
	TagGroup,
	TagSquare,
	StarScore,
	TagProduct,
	TagBrand,
	TagType,
	TagEmp,
	TagProcess,
	TagCode,
};
